<template>
  <header class="app-header">
    <div class="app-header__container container">
      <!-- navigation -->
      <this-nav />

      <!-- start -->
      <this-start />

      <!-- profile -->
      <this-profile />
    </div>
  </header>
</template>

<script>
import ThisNav from "./nav";
import ThisStart from "./start";
import ThisProfile from "./profile";

export default {
  name: "Header",

  components: {
    ThisNav,
    ThisStart,
    ThisProfile
  }
};
</script>

<style>
@import "./index.css";
</style>
